module.exports = __webpack_public_path__ + "img/xp.667d7ab4.svg";